(() => {
  "use strict";

  const isPrimaryNavigation = event => event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;

  const normalizeAccountLink = () => {
    document.querySelectorAll("a.header__icon--account").forEach(link => {
      link.href = "/account";
      link.removeAttribute("aria-haspopup");
    });
  };

  const updateCartCount = cart => {
    const count = Number(cart?.totalQuantity ?? cart?.item_count);
    if (!Number.isSafeInteger(count) || count < 0) return;
    document.querySelectorAll("#cart-icon-bubble").forEach(link => {
      let bubble = link.querySelector(".cart-count-bubble");
      if (!count) { bubble?.remove(); return; }
      if (!bubble) {
        bubble = document.createElement("div");
        bubble.className = "cart-count-bubble";
        const visible = document.createElement("span");
        visible.setAttribute("aria-hidden", "true");
        const accessible = document.createElement("span");
        accessible.className = "visually-hidden";
        bubble.append(visible, accessible);
        link.appendChild(bubble);
      }
      const [visible, accessible] = bubble.querySelectorAll("span");
      if (visible) visible.textContent = count < 100 ? String(count) : "";
      if (accessible) accessible.textContent = `${count} ${count === 1 ? "item" : "items"}`;
    });
  };

  normalizeAccountLink();
  const header = document.querySelector(".shopify-section-group-header-group");
  if (header) new MutationObserver(normalizeAccountLink).observe(header, { subtree: true, attributes: true, attributeFilter: ["href"] });
  document.addEventListener("cart:updated", event => updateCartCount(event.detail));

  document.addEventListener("click", event => {
    if (!isPrimaryNavigation(event)) return;

    const account = event.target.closest("a.header__icon--account");
    if (account) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign("/account");
      return;
    }

    const deadProductCta = event.target.closest('.product__description a[href="#"]');
    if (!deadProductCta) return;
    const form = document.querySelector('.product-form form[action*="/cart/add"]');
    const purchaseControl = form?.querySelector('button[type="submit"], input[type="submit"]');
    if (!form || !purchaseControl) return;
    event.preventDefault();
    form.scrollIntoView({ behavior: "smooth", block: "center" });
    purchaseControl.focus({ preventScroll: true });
  }, true);
})();
